/* eslint-disable react-hooks/exhaustive-deps */
import { connect } from 'react-redux'
import React, { useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import cn from 'classnames'
import { useVirtual } from "react-virtual"
import { isEmpty } from 'lodash'

import { addPaddingAndScrollUpToElement } from '../../utils/search'

import { getShowClosedTabs } from '../../selectors/search'

import TabOrderRow from './TabOrderRow'

import styles from './TabOrdersList.module.scss'

const TabOrdersList = ({ orders, theme, showHeader, onSelectOrder, onCloseOrder, onViewOrder, onMount, showClosedTabs, isSuites, className, isFocused, highlightedIds, searchQuery, focusedItemId }) => {
  const classNames = cn(styles.tabOrdersList, styles[theme], className)
  const listRef = useRef()
  let headerElement = null
  let content = null
  const rowVirtualizer = useVirtual({
    size: orders.length,
    parentRef: listRef,
    estimateSize: React.useCallback(() => 25, []),
    overscan: 2
  })

  useEffect(() => { onMount() }, [])
  useEffect(()=> {
      if(isFocused && listRef.current) {
        addPaddingAndScrollUpToElement(listRef.current.parentElement)
      }
  }, [isFocused])

  if (showHeader) {
    headerElement = (
      <div className={styles.header}>
        <span className={styles.paymentHeader}>Payment</span>
        <span>Amount</span>
        <span>Modified</span>
        <span>Order Number</span>
      </div>
    )
  }

  if (!isEmpty(orders)) {
    content = rowVirtualizer.virtualItems.map(virtualRow => {
        const order = orders[virtualRow.index]

        return <TabOrderRow
          className={styles.tabOrderRow}
          key={order.id}
          theme={theme}
          onSelectOrder={onSelectOrder}
          onCloseOrder={(orderId) => onCloseOrder(orderId, order.isMultiPayment)}
          onViewOrder={onViewOrder}
          isSuites={isSuites}
          searchQuery={searchQuery}
          highlightedIds={highlightedIds}
          focusedItemId={focusedItemId}
          style={{height: `${virtualRow.size}px`,
                transform: `translateY(${virtualRow.start}px)`}}
          {...order}
        />
      })
  } else if (showClosedTabs) {
    content = <p className={styles.noOrdersMessage}>No Orders</p>
  } else {
    content = <p className={styles.noOrdersMessage}>No Open Orders</p>
  }

  const style = {}

  if (searchQuery) {
    style.backgroundColor = '#11121d'
    style.paddingBottom = '32vw'
  }

  return (
    <div className={classNames} style={style}>
      {headerElement}
      <div
        ref={listRef}
        style={{
          width: "100%",
          overflow: "auto"
        }}
      >
        <div
          className="ListInner"
          style={{
            width: "100%",
            position: "relative"
          }}
        >
          {content}
        </div>
      </div>
    </div>
  )
}

TabOrdersList.defaultProps = {
  orders: [],
  theme: 'dark',
  showHeader: true,
  onSelectOrder: () => {},
  onCloseOrder: () => {},
  onViewOrder: () => {},
  onMount: () => {},
}

TabOrdersList.propTypes = {
  orders: PropTypes.array,
  theme: PropTypes.oneOf(['light', 'dark']),
  showHeader: PropTypes.bool,
  onSelectOrder: PropTypes.func,
  onCloseOrder: PropTypes.func,
  onViewOrder: PropTypes.func,
  onMount: PropTypes.func,
}

const mapStateToProps = (state) => {
  const showClosedTabs = getShowClosedTabs(state)

  return { showClosedTabs }
}

export default connect(mapStateToProps, null)(TabOrdersList)
